import React, { Component } from 'react'
import Axios from 'axios';
import {Link} from 'react-router-dom';
import '../../css/style.css';

import $ from 'jquery';
import Constant from '../Constant';
import { getAccessToken } from '../../hooks/AccessToken';

class AddUpdate extends Component {

/*..................................... default state object ............................................*/
    
    state = {
        name: '',
        image: null,
        contestType: 0,
        getData: {},
        selectArea: 0,
        ERROR: true
    }


    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        })
    };  

    handleImageChange = (e) => {
        this.setState({
            [e.target.id]: e.target.files[0]
        })
    };
  

/*.................. Integrate API for update banner...............................................*/

    handleSubmit = async event => {
        try{
            event.preventDefault();
            let token = getAccessToken();
            let id = this.props.match.params.id;
            const form_data = new FormData();
           
            if(id === undefined) {
                if(this.state.image === null) {
                    $("#error-banner-msg").text('File is required');
                    $("#error-banner-msg").css("color", "red");
                    return false;
                }
    
                let fileName = this.state.image.name;
                let extension = fileName.split('.').pop();
    
                if(extension !== 'jpg' && extension !== 'png') {
                    $("#error-banner-msg").text('Only jpg and png file type are allow !');
                    $("#error-banner-msg").css("color", "red");
                    return false;
                }

                form_data.append('name', this.state.name);  
                form_data.append('icon', this.state.image, this.state.image.name);  
                form_data.append('contestType', this.state.contestType);
                Axios.post(Constant.apiBasePath + 'category/create', form_data, { headers: { 'token': token }}).then(response => {
                const getResults = response.data.message;
                
                    if(response.data.status === Constant.statusSuccess) {
                        $('#gen-message').text(getResults);
                        $('#gen-message').css('color', 'green');
                        setTimeout(function() { window.location.reload(); }, 3000 );
                    }
    
                    else {
                        $('#gen-message').text(getResults);
                        $('#gen-message').css('color', 'red');
                        return false;
                    }
    
                });
            }

            else {
                let getData = this.state.getData;
                (this.state.name) ? form_data.append('name', this.state.name) : form_data.append('name', getData.name); 
                (this.state.image) ? form_data.append('icon', this.state.image, this.state.image.name) : form_data.append('icon', getData.icon);   
                form_data.append('contestType', this.state.contestType);
             
                Axios.patch(Constant.apiBasePath + 'category/edit/' + id, form_data, { headers: { 'token': token }}).then(response => {
                    const getResults = response.data.message;

                    if(response.data.status === Constant.statusSuccess) {
                        $('#gen-message').text(getResults);
                        $('#gen-message').css('color', 'green');
                        setTimeout(function() { window.location.href = '/category-management'; }, 3000 );
                    }
                    else {
                        $('#gen-message').text(getResults);
                        $('#gen-message').css('color', 'red');
                        return false;
                    }
                });
            }

        }
        catch(err) {
            console.log(err);
        }       
    }

    getgetData(id){
        let token = getAccessToken();
        let req = {
            method: 'GET',
            url: Constant.apiBasePath + 'category/getDataById/' + id,
            headers:
            {
                'Content-Type': 'application/x-www-form-urlencoded',
                'token': token
            },
            json: true
        }
        Axios(req).then(response => {
            const {data} = response;
            if (data.status === Constant.statusSuccess) {
                this.setState({ getData: data.data[0], ERROR: false });
            }
            else {
                this.setState({ getData: '', ERROR: false });
            }
        }).catch(error => ('Something Error'));

    }

    componentDidMount() {
        let id = this.props.match.params.id;
        if(id !== undefined) {
            this.getgetData(id);
        }
    }
    

/*.................................end API .................................................................*/

    render() {
        const { getData } = this.state;
        let name = '';
        let image = '';
        let btnVal = 'Add';
        let heading = 'Add Category';
        
        if(getData.name !== undefined) {
            name = getData.name;
            image = (getData.icon === undefined) ? '' : getData.icon;
            btnVal = 'Update';
            heading = 'Update Category';
        }
        
        return (
                <div className="content-page contest-add-update-page event-consistent-page category-add-page">
                    <div className="content page-content-spaced">
                        <div className="event-management-header">
                            <div className="header-content">
                                <div className="header-title">
                                    <h4 className="page-title-heading">{heading}</h4>
                                    <p className="header-subtitle">Create or update multimedia categories and icon details.</p>
                                </div>
                                <div className="header-actions">
                                    <Link to="/category-management" className="btn openmic-link-btn">Back to Category Management</Link>
                                </div>
                            </div>
                        </div>

                        <div className="event-management-body">
                            <div className="row">
                                <div className="col-12 contest-form-column">
                                    <div className="card contest-form-card">
                                        <div className="card-body contest-form-card-body"> 
                                        <form onSubmit={this.handleSubmit}>
                                            <p id="gen-message" className="message-feedback"></p>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="name" className="update">Name *</label>
                                                            <input type="text" id="name" className="form-control" onChange={this.handleChange} 
                                                            defaultValue={name} />         
                                                    </div> 
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="contestType" className="update">Type of category *</label>
                                                            <select id="contestType" className="form-control" onChange={this.handleChange}>
                                                                <option id="0" value="0" selected={getData.contestType == 0}>For General</option>
                                                                <option id="1" value="1" selected={getData.contestType == 1}>For Contest</option>
                                                            </select>         
                                                    </div> 
                                                </div>
                                            </div>
                               
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="updateImage" className="update">Image *</label>
                                                        <input type="file" id="image" name="image" accept="image/png, image/jpg"  className="form-control" onChange={this.handleImageChange} 
                                                        />   
                                                        <p id="error-banner-msg"></p>
                                                    </div> 
                                                </div> 
                                            </div>
                                                {
                                                    (getData.name !== undefined) ?

                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group mb-3" id="">
                                                                <label className="label1" htmlFor="Image">Old Image :</label>
                                                                <img src={image} alt="ind" id="background-img" width="80" height="60" className="oldImage"/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    :
                                                    ''
                                                }

                                            <div className="d-flex flex-wrap align-items-center" style={{ gap: '10px' }}>
                                                <button type="submit" className="btn btn-info">{btnVal}</button>
                                                <Link to="/category-management" className="btn openmic-link-btn">Cancel</Link>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
        )
    }
}
export default AddUpdate;


